// extracted by mini-css-extract-plugin
export default {"Anchor":"StartChat_Anchor__-JImt","Container":"StartChat_Container__F0wls","Contact":"StartChat_Contact__JpCCA","TgLogo":"StartChat_TgLogo__BQ0wW"};